<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="20"
    viewBox="0 0 17 20"
    class="pt-[1.693px] pr-[3.068px] pb-[2.247px] pl-[3.387px]"
    fill=""
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.0625 18.6077C0.0625 18.223 0.374378 17.9111 0.759099 17.9111H15.6199C16.0046 17.9111 16.3165 18.223 16.3165 18.6077C16.3165 18.9925 16.0046 19.3043 15.6199 19.3043H0.759099C0.374378 19.3043 0.0625 18.9925 0.0625 18.6077Z"
      fill="currentColor"
    />
    <path
      d="M7.74242 12.0402L7.74245 12.0402L13.2379 6.5448C12.4899 6.23351 11.6041 5.72217 10.7663 4.88438C9.92836 4.04645 9.417 3.16045 9.10572 2.41245L3.61021 7.90796L3.61017 7.908C3.18135 8.33682 2.96692 8.55125 2.78252 8.78767C2.56498 9.06657 2.37848 9.36834 2.22631 9.68763C2.09731 9.95831 2.00142 10.246 1.80963 10.8214L0.79827 13.8554C0.703889 14.1386 0.777581 14.4507 0.988623 14.6618C1.19967 14.8728 1.51183 14.9465 1.79498 14.8521L4.82905 13.8408C5.40441 13.649 5.69211 13.5531 5.96278 13.4241C6.28208 13.2719 6.58384 13.0854 6.86274 12.8679C7.09916 12.6835 7.3136 12.4691 7.74242 12.0402Z"
      fill="currentColor"
    />
    <path
      d="M14.7628 5.01989C15.9039 3.8788 15.9039 2.02873 14.7628 0.887645C13.6217 -0.253442 11.7716 -0.253442 10.6305 0.887645L9.97142 1.54675C9.98045 1.574 9.98981 1.60164 9.99952 1.62963C10.2411 2.32596 10.6969 3.23879 11.5544 4.09627C12.4119 4.95374 13.3247 5.40956 14.021 5.65115C14.0489 5.66081 14.0764 5.67013 14.1035 5.67912L14.7628 5.01989Z"
      fill="currentColor"
    />
  </svg>
</template>